<template>
	<div class="supplier-box por" :class="`${col}`" @mouseenter="currentHover = true" @mouseleave="currentHover = false"
		@click="productDetail(item)">
		<div v-if="item.main_pics"
			:style="{ backgroundImage: 'url(' + item.main_pics[0] + ')', width: isMobile ? '11rem' : '15rem', 'min-height': isMobile ? '11rem' : '15rem' }"
			class="hover-up main-img transition-normal fadeIn animated"></div>
		<el-collapse-transition>
			<div class="attributes poa df fdc aife transition-normal fadeIn" v-show="currentHover && !isMobile">
				<!-- <div v-if="item.category">
					<span class="df attribute aic jcfs">Type:{{item.category.name}}</span>
				</div> -->
				<div v-if="item.brand">
					<span class="df attribute aic jcfs">Brand:{{ item.brand.name }}</span>
				</div>
				<div v-if="item.country">
					<span class="df attribute aic jcfs">Origin:{{ item.country.englishName }}</span>
				</div>
			</div>
		</el-collapse-transition>
		<div :style="`${isMobile ? 'font-size: 1rem;' : 'font-size: 1.05rem;'}`" class="main-title text_over_2line"
			v-text="item.title"></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			currentHover: undefined,
			isMobile: false
		}
	},
	props: {
		col: {
			type: String,
			default: 'col-3'
		},
		item: Object
	},
	mounted() {
		this.isMobile = localStorage.getItem('isMobile') == 'null' ? false : true
	},
	methods: {
		productDetail(item) {
			if (!this.islogin) {
				if (this.isMobile) {
					this.$router.push({
						name: 'mlogin',
						query: {
							type: 1
						}
					})
				} else {
					localStorage.setItem('logintype', 1)
					this.$bus.$emit("login", true);
				}
			} else {
				this.$router.push({
					name: 'productDetail',
					query: {
						id: item.id
					}
				})
				location.reload();
			}
		},
	}
}
</script>

<style scoped>
.main-title {
	color: #000;
	font-weight: bold;
	margin-top: 0.5rem;
	width: 100%;
}

.attributes {
	top: 1rem;
	right: 1.5rem;
}

.attribute {
	flex: 1;
	display: inline-block;
	background-color: #000;
	color: #fff;
	padding: 0.2rem 1rem;
	border-radius: 1.5rem;
	margin-top: 0.2rem;
}

.supplier-box {
	background-color: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	cursor: pointer;
	margin-bottom: 2rem;
	/* margin-right: 1rem; */
	border-radius: 0.5rem;

}

/* @media (max-width:767px) {
		.supplier-box:nth-child(1n) {
			transform: translateX(3px);
		}
		.supplier-box:nth-child(2n) {
			transform: translateX(-3px);
		}
	} */

.main-img {
	background-position: center;
	background-size: contain;
	background-repeat: no-repeat;
	/* border: 0.05rem solid rgba(0, 0, 0, 0.1); */
	border-radius: 8px;
	max-width: 100%;

	&:hover {
		box-shadow: 0 10px 10px rgba(0, 0, 0, 0.08);
	}
}

.col-custom {
	margin: 0 0 0 10px;
	width: calc((100% - 10px*5)/5)
}
</style>